import { render, staticRenderFns } from "./inviteEmail.vue?vue&type=template&id=52d5c567"
import script from "./inviteEmail.vue?vue&type=script&lang=js"
export * from "./inviteEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports